import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { psasApi } from "@api/services";
import {
  ACTION_GET_FORM_DRAFT_DATA,
  DOMAIN_FORM_SUBMISSIONS,
  roleGuard,
} from "@api";
import { DOMAIN_PSAS } from "@api/hooks/psas/domain";

export const ACTION_PSAS_IMPORT_TO_FORM = "PSAS_IMPORT_TO_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

type PsasImportToFormRequest = {
  formId: string;
};

const psasImportToForm = async (req: PsasImportToFormRequest): Promise<void> => {
  await psasApi.psasControllerImportToForm(req.formId);
};

export const usePsasImportToForm = (
  user: UserProfileDto | null,
  formId: string,
): {
  psasImportToFormAsync: UseMutateAsyncFunction<
    void,
    Error,
    PsasImportToFormRequest,
    unknown
  >;
  psasImportToFormEnabled: boolean;
  isSuccessPsasImportToForm: boolean;
  isPendingPsasImportToForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_PSAS, ACTION_PSAS_IMPORT_TO_FORM],
    mutationFn: enabled ? psasImportToForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FORM_SUBMISSIONS, ACTION_GET_FORM_DRAFT_DATA, formId],
      });
    },
  });

  return {
    psasImportToFormAsync: mutateAsync,
    psasImportToFormEnabled: enabled,
    isSuccessPsasImportToForm: isSuccess,
    isPendingPsasImportToForm: isPending,
  };
};
